import { createContext, useContext } from 'react';

/** Provided by the app shell (src/navigation/Shell.tsx); consumed by PageHeader / Screen. */
export interface ShellValue {
  isWide: boolean;
  /** screen names that are bottom-tab roots (no back button on phones) */
  tabRoots: Set<string>;
  /** non-hidden registry screens (reachable from the sidebar; no back button on wide screens) */
  topLevel: Set<string>;
  openPalette: () => void;
  openNotifications: () => void;
  unread: number;
  /** navigate to a registry screen by name (see src/navigation/nav.ts) */
  go: (name: string, params?: Record<string, unknown>) => void;
}

export const ShellContext = createContext<ShellValue>({
  isWide: false,
  tabRoots: new Set(),
  topLevel: new Set(),
  openPalette: () => {},
  openNotifications: () => {},
  unread: 0,
  go: () => {},
});

export const useShell = () => useContext(ShellContext);
